import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import iso1 from '../assets/images/iso1.jpeg';
import iso2 from '../assets/images/iso2.jpeg';
import iso3 from '../assets/images/iso3.jpeg';
import { FaTimes } from 'react-icons/fa';

const Certificate = () => {
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const certificates = [
    {
      id: 1,
      image: iso1,
      title: "ISO 14001:2015 Certificate",
      filename: "ISO_14001_2015_Certificate.pdf"
    },
    {
      id: 2,
      image: iso2,
      title: "ISO 9001:2015 Certificate",
      filename: "ISO_9001_2015_Certificate.pdf"
    },
    {
      id: 3,
      image: iso3,
      title: "ISO 45001:2015 Certificate",
      filename: "ISO_45001_2015_Certificate.pdf"
    }
  ];

  // Prevent body scrolling when modal is open
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  const viewCertificate = (certificate) => {
    setSelectedCertificate(certificate);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedCertificate(null);
  };

  // Prevent right-click and download
  const preventDownload = (e) => {
    e.preventDefault();
    return false;
  };

  return (
    <section className="certificate-section" id="certificates">
      <div className="container">
        <h2>Our Certifications</h2>
        <p className="section-intro">
          We are proud to maintain the highest standards of quality and excellence in all our operations.
        </p>

        <div className="certificates-grid">
          {certificates.map((certificate) => (
            <div key={certificate.id} className="certificate-item">
              <img
                src={certificate.image}
                alt={certificate.title}
                className="certificate-img"
              />
              <div className="certificate-link-container">
                <button
                  onClick={() => viewCertificate(certificate)}
                  className="certificate-link-btn"
                >
                  {certificate.title}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal via React Portal */}
      {showModal && selectedCertificate &&
        ReactDOM.createPortal(
          <div className="certificate-modal-overlay" onClick={closeModal}>
            <div className="certificate-modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="certificate-close-btn" onClick={closeModal}>
                <FaTimes />
              </button>
              <h3>{selectedCertificate.title}</h3>
              <div className="certificate-pdf-container">
                <iframe
                  src={`https://alafoogarage.com/ahalafoo/uploads/certificates/${selectedCertificate.filename}`}
                  title={selectedCertificate.title}
                  className="certificate-pdf"
                  onContextMenu={preventDownload}
                />

              </div>
            </div>
          </div>,
          document.body
        )
      }
    </section>
  );
};

export default Certificate;
